import { supabase } from "@/supabase";
import { ref } from "vue";
import { StorageService } from "./storage.service";
import { storage_url } from "../utils/general";

const _COMPANY = "company";
const _BRANDS_COMPANIES = "brands_companies";

export const companies = ref([]);
export const company = ref({});
export const companiesCount = ref(0);
export const companyFilters = ref({});

let _app;

export const CompanyService = {
  setApp(appInstance) {
    _app = appInstance;
  },
  get toast() {
    return _app.config.globalProperties.$toast;
  },
 async getCompany(id) {
  const { data: company, error } = await supabase
   .from(_COMPANY)
   .select("*")
   .eq("id", id)
   .single();
  if (error) {
   this.toast.error(error.message);
   return undefined;
  }
  if (company) {
   if (company.logo) {
     company.logo = storage_url + company.logo;
   }
   return company;
  }
  return undefined;
 },
 async selectCompany(data) {
  company.value = data;
 },
 async getCompanies() {
  try {
   const company_data = supabase.from(_COMPANY).select("*", { count: "exact" });
   if (companyFilters.value.company_name) {
    company_data.filter(
     "company_name",
     "ilike",
     `%${companyFilters.value.company_name}%`
    );
   }
   company_data.order("company_name", { ascending: true });
   const { data, count, error } = await company_data;
   if (error) {
    this.toast.add({ severity: "error", detail: error.message, life: 5000 });
    return;
   }
   if (data === null) {
    companies.value = [];
    return;
   }
   companiesCount.value = count;
   companies.value = data;
   for (const company of companies.value) {
    if (company.logo && !company.logo.startsWith('http')) {
      company.logo = storage_url + company.logo;
    }
   }
  } catch (err) {
   this.toast.add({ severity: "error", detail: err.message, life: 5000 });
  }
 },
 async getAllCompanies() {
  try {
   const company_data = supabase.from(_BRANDS_COMPANIES).select("companies").single();
   const { data, error } = await company_data;
   if (error) {
    this.toast.add({ severity: "error", detail: error.message, life: 5000 });
    return;
   }
   if(data.companies){
    companiesCount.value = data.companies.length;
    companies.value = data.companies;
    for (const company of companies.value) {
      if (company.logo && !company.logo.startsWith('http')) {
        company.logo = storage_url + company.logo;
      }
    }
   }
  } catch (err) {
   this.toast.add({ severity: "error", detail: err.message, life: 5000 });
  }
 },
 async addCompany(data) {
  try {
   const companyObj = await this._getCompanyObject(data);
   const { error: companyError } = await supabase
    .from(_COMPANY)
    .insert(companyObj)
    .single();
   if (companyError) {
    this.toast.add({ severity: "error", detail: companyError.message, life: 5000 });
    return;
   }
   this.toast.add({ severity: "success", detail: "Company added successfully", life: 5000 });
  } catch (err) {
   this.toast.add({ severity: "error", detail: err.message, life: 5000 });
  }
 },
 async updateCompany(data) {
  try {
   const companyObj = await this._getCompanyObject(data);

   const { error: companyError } = await supabase
    .from(_COMPANY)
    .update(companyObj)
    .eq("id", data.id)
    .single();

   if (companyError) {
    this.toast.add({ severity: "error", detail: companyError.message, life: 5000 });
    return;
   }
   this.toast.add({ severity: "success", detail: "Company updated successfully", life: 5000 });
  } catch (err) {
   this.toast.add({ severity: "error", detail: err.message, life: 5000 });
  }
 },
 // Updates only the client_protocols column for a company. Kept separate from
 // updateCompany so saving shared protocols never overwrites name/logo/etc.
 async updateCompanyProtocols(id, client_protocols) {
  const resp = { updated: false, error: null };
  const { error } = await supabase
   .from(_COMPANY)
   .update({ client_protocols })
   .eq("id", id)
   .single();
  if (error) {
   resp.error = error.message;
   return resp;
  }
  resp.updated = true;
  return resp;
 },
 async _getCompanyObject(data) {
if (data.logo_file) {
    const { data: file, error } = await StorageService.upload(
        data.logo_file,
        "logo"
    );
    if (error) throw error;
    if (file) {
        if (data) {
        data.logo = file.path;
        }
    }
    }
     
  const companyObj = {};
  if (data.company_name) companyObj.company_name = data.company_name;
  if (data.logo) companyObj.logo = data.logo;
  if (data.website) companyObj.website = data.website;
  companyObj.is_dashboard_customized = data.is_dashboard_customized;
  if (data.color) companyObj.color = data.color;
  return companyObj;
 },
};
